import { Component, OnInit } from '@angular/core';
import { Role } from '../../models/User';
import { ReportService } from '../../services/report.service';
import { TabularReport } from '../../models/Report';
import { AccountService } from '../../services/account.service';
import { ErisLoginService } from '../../services/sso/eris-login.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  tabularReports: TabularReport[] = [];
  allTabularReports: TabularReport[] = []; 
  reportGroups = [ {code : "ALL", name: "All"},
                   {code : "ILICENSE" , name: "i-License"},
                  {code : "IINSPECT" , name: "i-Inspect"}
                ];
  selectedReportGroupCode = "ALL";


  constructor( private reportService: ReportService, private erisLoginService: ErisLoginService) {
      const colorTheme = 'theme-green';
  }

  ngOnInit() {
    this.getTabularReports();
  }

  getTabularReports(){
    this.reportService.getTabularReportListByUser(this.erisLoginService.getUserId()).subscribe(
      resp => {
        this.tabularReports = resp;
        this.allTabularReports = resp;
    });
  }

  reportGroupChanged(){
    if (this.selectedReportGroupCode == "ALL") {
      this.tabularReports = this.allTabularReports;
    } else {
      this.tabularReports = this.allTabularReports.filter(t => t.report.reportGroup == this.selectedReportGroupCode);
    }
  }
}